import { ThemeUIStyleObject } from "theme-ui";

export type FontSize = "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";
export type FontWeight = "light" | "regular" | "semibold";

/**
 * Responsive font sizes at different breakpoints.
 */
const sizeSx: { [key in FontSize]: ThemeUIStyleObject } = {
  xs: {
    fontSize: [0, 0],
  },
  sm: {
    fontSize: [0, 1],
  },
  md: {
    fontSize: [1, 2],
  },
  lg: {
    fontSize: [2, 3],
  },
  xl: {
    fontSize: [3, 4],
  },
  "2xl": {
    fontSize: [4, 5],
  },
  "3xl": {
    fontSize: [5, 6],
  },
};

const weightSx: { [key in FontWeight]: ThemeUIStyleObject } = {
  light: {
    fontWeight: "light",
  },
  regular: {
    fontWeight: "regular",
  },
  semibold: {
    fontWeight: "semibold",
  },
};

export const getFontSizeSx = (size: FontSize): ThemeUIStyleObject =>
  sizeSx[size];

export const getFontWeightSx = (weight: FontWeight): ThemeUIStyleObject =>
  weightSx[weight];
